export default __webpack_public_path__ + "static/media/MaterialIcons-Regular.2705e9ec.ttf";